module.exports = __webpack_public_path__ + "media/images/dashboard/stretchlab-banner-bg-d1eb3c4d8565886c93b5682a010f19d4.jpg";